<template>
  <v-app>
    <v-container v-if="raffle" fill-height fluid class="ma-5">
      <v-row v-if="raffle.status <= 1" align="center" justify="center">
        <v-col cols="12" class="text-center"
          ><h1>Chave do sorteio: {{ raffle.name }}</h1></v-col
        >
        <v-col cols="12">
          <countdown v-if="countdown > 0" :time="countdown" class="text-center">
            <template slot-scope="props">
              <div
                v-if="
                  props.days > 0 ||
                    props.hours > 0 ||
                    props.minutes > 0 ||
                    props.seconds
                "
              >
                <span class="text-h4">O sorteio acontecerá em:</span>
                <br />
                <span class="text-h4" v-if="props.days === 1"
                  >{{ props.days }} dia,
                </span>
                <span class="text-h4" v-else-if="props.days > 0"
                  >{{ props.days }} dias,
                </span>

                <span class="text-h4" v-if="props.hours === 1"
                  >{{ props.hours }} hora,
                </span>
                <span class="text-h4" v-else-if="props.hours > 0"
                  >{{ props.hours }} horas,
                </span>

                <span class="text-h4" v-if="props.minutes === 1"
                  >{{ props.minutes }} minuto,
                </span>
                <span class="text-h4" v-else-if="props.minutes > 0"
                  >{{ props.minutes }} minutos,
                </span>

                <span class="text-h4" v-if="props.seconds === 1"
                  >{{ props.seconds }} segundo.</span
                >
                <span class="text-h4" v-else-if="props.seconds > 0"
                  >{{ props.seconds }} segundos.</span
                >
              </div>
              <div v-else>
                O sorteio terminou! Atualize a página para ver o resultado!
              </div>
            </template>
          </countdown>
        </v-col>
        <v-col cols="12" class="text-center"
          ><span class="text-h6"
            ><a :href="`https://t.me/sorteadortelegrambot?start=${raffle.name}`"
              >Para participar clique neste LINK com seu smartphone
              <br />(https://t.me/sorteadortelegrambot?start={{
                raffle.name
              }})</a
            ><br />
            Ou envie a mensagem "<b>/start {{ raffle.name }}</b
            >" para @SorteadorTelegramBot</span
          ></v-col
        >
        <v-col cols="12" class="text-center">
          <v-btn x-large color="#283593" dark @click="dialogs.prizes = true"
            ><v-icon class="mr-2">fas fa-gifts</v-icon>Ver prêmios<v-icon
              class="ml-2"
              >fas fa-gift</v-icon
            ></v-btn
          >
        </v-col>
      </v-row>
      <v-row v-else align="center" justify="center">
        <v-col cols="12" class="text-center"
          ><span class="text-h3">O sorteio já foi finalizado!</span></v-col
        >
      </v-row>
    </v-container>
    <v-container v-else fill-height fluid class="ma-5">
      <v-row v-if="raffle.status <= 1" align="center" justify="center">
        <v-col cols="12" class="text-center"
          ><span class="text-h2">CARREGANDO ...</span></v-col
        >
      </v-row>
    </v-container>
    <v-footer class="justify-center" color="#292929" height="60">
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >
        &copy; {{ new Date().getFullYear() }} — Vuetify, LLC
      </div>
    </v-footer>
    <v-dialog v-model="dialogs.prizes">
      <v-card>
        <v-card-title class="headline">
          Prêmios do sorteio
        </v-card-title>

        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'auth',
  components: {},
  data: () => ({
    raffle: null,
    searching: false,
    loading: true,
    countdown: 0,
    dialogs: {
      prizes: false
    }
  }),
  created() {
    var vm = this
    vm.fetchRaffle(vm.$route.params.id)
  },
  methods: {
    openLink(_url) {
      window.open(_url, '_blank')
    },
    fetchRaffle(_raffleID) {
      var vm = this
      vm.searching = true
      vm.$API
        .Request('post', `raffle/get/${_raffleID}`)
        .then(result => {
          if (result && result.data) {
            vm.raffle = result.data
            let _now = new Date()
            let _raffle = new Date(vm.raffle.raffle)
            vm.countdown = _raffle.getTime() * 1000 - _now.getTime()
          }
          console.debug(vm.raffle)
          vm.searching = false
          vm.loading = false
        })
        .catch(error => {
          vm.searching = false
          console.debug(error)
          if (error && error.message) {
            vm.$snotify.error(error.message)
          }
        })
    }
  }
}
</script>
